import { render, staticRenderFns } from "./CompanyGrid.vue?vue&type=template&id=3d4a04fb&"
import script from "./CompanyGrid.vue?vue&type=script&lang=js&"
export * from "./CompanyGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports